@if (loadingBarService.isLoading()) {
	<div class="loading-bar" role="progressbar" aria-label="Carregando">
		<div class="loading-bar__progress"></div>
	</div>
}
